import {
  useId,
  type ReactNode,
  type SelectHTMLAttributes,
  type TextareaHTMLAttributes,
} from 'react';
import { cn } from './cn';

const BORD =
  'rounded-[10px] border border-border bg-surface px-3 text-sm text-ink placeholder:text-faint focus:border-primary focus:ring-3 focus:ring-primary-subtle focus:outline-none';

export function ChampListe({
  libelle,
  erreur,
  className,
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & {
  libelle: string;
  erreur?: string | undefined;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-[13px] font-medium">
        {libelle}
      </label>
      <select
        id={id}
        className={cn(BORD, 'h-10', erreur && 'border-danger-border', className)}
        {...props}
      >
        {children}
      </select>
      {erreur ? <p className="text-xs text-danger">{erreur}</p> : null}
    </div>
  );
}

export function ChampTexte({
  libelle,
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { libelle: string }) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-[13px] font-medium">
        {libelle}
      </label>
      <textarea id={id} rows={3} className={cn(BORD, 'py-2', className)} {...props} />
    </div>
  );
}

export function Grille({ children }: { children: ReactNode }) {
  return <div className="grid gap-4 sm:grid-cols-2">{children}</div>;
}

export function PleineLargeur({ children }: { children: ReactNode }) {
  return <div className="sm:col-span-2">{children}</div>;
}

export function ErreurFormulaire({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p
      role="alert"
      className="mt-4 rounded-xl border border-danger-border bg-danger-bg px-3.5 py-2.5 text-[13px] text-danger"
    >
      {message}
    </p>
  );
}
